import React, { ChangeEvent, useState, useEffect } from 'react';
import { styled } from '@material-ui/core/styles';
import './thankYou.css';

import logoImage from '../images/logo.png';
import thankYouImage from '../images/thank-you.png';

const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
});

const Main = styled('main')({
  height: '100%',
  position: 'relative',
});

export default function App() {

  return (
    <div className="pageWrapper">
      <div className="container">
         <div className="row">
         <div className="col-12 text-center">
         <header className="header">
            <div className="logo-thank-you">
               <img src={logoImage} width="95" />
            </div>
          </header>
         </div>
         </div>
          <section className="content">
             <div className="row">
               <div className="col-lg-6 m-auto col-12">
                  <div className="thank-you-block">
                     <img src={thankYouImage} width="95" />
                     <h1>Thank You</h1>
                     <h2>The video call has ended</h2>
                  </div>
                  </div>
             </div>
          </section>
         
      </div>
      </div>
  
  );
}
